<template>
  <v-select
    dense
    outlined
    label="Cell"
    v-model="cell"
    :items="cells"
    prepend-inner-icon="mdi-crosshairs"
  ></v-select>
</template>

<script>
import {
  mapGetters,
  mapMutations,
  mapActions,
} from 'vuex';

const FIELD_NAME = 'cellname';

export default {
  name: 'CellSelection',
  computed: {
    ...mapGetters('webApp', ['filters']),
    ...mapGetters('manpowerLog', ['cellList']),
    isCellFilterInactive() {
      return !Object
        .keys(this.filters)
        .includes(FIELD_NAME);
    },
    cells() {
      let cells = [];
      if (this.cellList && this.cellList.length) {
        cells = [...this.cellList];
      }
      return cells;
    },
    targetManpower() {
      let targetManpower = [];
      if (this.manpower && this.manpower.length) {
        targetManpower = [...this.manpower];
      }
      return targetManpower;
    },
    cell: {
      get() {
        const cellFilter = this.filters && this.filters[FIELD_NAME];
        if (cellFilter) {
          return cellFilter.value;
        }
        return this.cells && this.cells.length && this.cells[0].value;
      },
      set(cellVal) {
        this.setCellFilter(cellVal);
      },
    },
  },
  created() {
    if (this.cells && this.cells.length) {
      if (this.isCellFilterInactive) {
        this.setCellFilter(this.cells[0].value);
      }
    } else {
      this.fetchCells();
    }
  },
  methods: {
    ...mapMutations('webApp', ['setFilter']),
    ...mapActions('manpowerLog', ['fetchCells', 'fetchManpowerList']),
    setCellFilter(val) {
      this.setFilter({
        field: FIELD_NAME,
        value: {
          value: val,
          operation: 'eq',
        },
      });
    },
  },
  watch: {
    cells(val) {
      if (val && val.length) {
        if (this.isCellFilterInactive) {
          this.setCellFilter(val[0].value);
        }
      }
    },
  },
};
</script>
